import { gql } from "@apollo/client"; import { useLazyQuery, useMutation } from "@apollo/client/react"; import React, { useEffect, useState } from 'react';

import '../../../assets/css/App.css';
import Box from '@mui/material/Box';
import SaveIcon from '@mui/icons-material/Save';
import SeccionUsuario from './SeccionUsuario';
import { useLocation, useNavigate } from 'react-router-dom';
import SeccionRol from './SeccionRol';
import SeccionDelegacion from './SeccionDelegacion';
import SeccionProfesional from './SeccionProfesional';
import SeccionPreview from './SeccionPreview';
import toast, { Toaster } from 'react-hot-toast';

import ErrorDialog from '../../../components/ErrorDialog';
import SeccionPaciente from './SeccionPaciente';
import SeccionCliente from './SeccionCliente';
import { Stepper } from '../../../components/stepper/Stepper';
import { CustomButton } from '../../../components/customButton/CustomButton';

import './usuarioAdminItemLayout.scss';
export default function UsuarioAdminItemLayout({ setChildrenAction, setHeaderContent }) {

  const idUsuarioLogin = parseInt(sessionStorage.getItem("idUsuario"), 10);
  const [activeStep, setActiveStep] = useState(0);
  const [loadingGrabar, setLoadingGrabar] = useState(false);

  // para sección usuario
  const [usuarioAuth, setUsuarioAuth] = useState({
    Id: 0,
    Usuario: '',
    Clave: '',
    Nombre: '',
    Apellido: '',
    TipoDocumento: '',
    NumeroDocumento: '',
    IdUsuario: 0,
    Sexo: '',
    FechaNacimiento: '',
    Email: '',
    Telefono: '',
    TipoUsuario: ''
  });

  // para sección roles
  const [rolesSeleccionados, setRolesSeleccionados] = useState("");

  // para sección delegaciones
  const [regiones, setRegiones] = useState([]);
  const [delegaciones, setDelegaciones] = useState([]);
  const [delegacionesSeleccionadas, setDelegacionesSeleccionadas] = useState([]);
  const [delegacionOrigen, setDelegacionOrigen] = useState('');
  const [steps, setSteps] = useState(STEPS);

  // para sección profesional
  const [profesional, setProfesional] = useState("");
  const [instituciones, setInstituciones] = useState([]);

  // para sección paciente
  const [pacienteSeleccionado, setPacienteSeleccionado] = useState("");

  // para sección cliente
  const [clientesSeleccionados, setClientesSeleccionados] = useState('');

  // objeto para enviar a grabar
  const [usuarioSave, setUsuarioSave] = useState(
    {
      usuario: '',
      roles: '',
      delegaciones: ''
    }
  );

  // dlg de error
  const [opendDlgError, setOpenDlgError] = useState(false);
  const [mensajeError, setMensajeError] = useState("");

  // parámetros recibidos por QueryString
  const { state } = useLocation();
  const { usuario, edit } = state;

  // constantes
  const TIPO_USUARIO_INTERNO = 4;
  const TIPO_USUARIO_PACIENTE = 5;
  const TIPO_USUARIO_CLIENTE = 1;

  useEffect(() => {
    if (edit) {
      getDatosFull({ variables: { idUsuario: usuario.idUsuario } });
    }
  }, []);

  useEffect(() => {
    setOpenDlgError(mensajeError !== "");
  }, [mensajeError]);

  const navigate = useNavigate();

  useEffect(() => {
    setChildrenAction(() =>
      <div
        className='user-admin-item-footer'>
        <CustomButton
          disabled={activeStep === 0}
          onClick={handleBack}
          previousArrow
          size="small"
          variant="outlined"
          noOutline={true}
          className='back-button'>

          Anterior
        </CustomButton>
        <div className='button-divider'></div>
        {activeStep === steps.length - 1 ?
          <CustomButton
            isLoading={loadingGrabar}
            loadingPosition="end"
            onClick={handleSave}
            size="small"
            variant="contained"
            disableElevation
            disabled={loadingGrabar}>

            Grabar
          </CustomButton> :
          <CustomButton
            onClick={handleNext}
            size="small"
            nextArrow
            variant="outlined"
            noOutline={true}>

            Siguiente
          </CustomButton>}
      </div>
    );

    setHeaderContent(() =>
      <div className='user-header-stepper'>
        <Stepper
          steps={steps} />

      </div>
    );
  }, [
    steps,
    usuarioAuth,
    delegacionOrigen,
    delegacionesSeleccionadas,
    rolesSeleccionados,
    pacienteSeleccionado,
    clientesSeleccionados,
    loadingGrabar]
  );

  const handleNext = () => {
    const currentStep = steps?.find((step) => step.status.toUpperCase() === 'ACTIVE');
    const { order } = currentStep;
    if (isStepValid(order)) {
      let nuevoStep = order + 1;

      // El Step siguiente a Delegación va a depender del tipo de Usuario.
      // El Step siguiente a Profesional/Paciente/Cliente es directamente Previsualizar, ya que
      // solo se pasará por alguno de esos 3 steps descriptos al principio.

      // Delegación --> Profesional/Paciente/Cliente
      if (order === 2) {
        if (usuarioAuth.IdTipoUsuario === TIPO_USUARIO_PACIENTE) {
          nuevoStep = 4;
        } else if (usuarioAuth.IdTipoUsuario === TIPO_USUARIO_CLIENTE) {
          nuevoStep = 5;
        }
      }

      // Profesional/Paciente/Cliente --> Previsualizar
      if (order === 3 || order === 4 || order === 5) {
        nuevoStep = 6;
      }

      setActiveStep(nuevoStep);
      setSteps(steps?.map((step) => {
        if (step.order === nuevoStep) {
          return { ...step, status: 'ACTIVE' };
        } else if (step.order < nuevoStep) {
          return { ...step, status: 'COMPLETED' };
        } else {
          return { ...step, status: 'INACTIVE' };
        }
      }));
    }
  };

  const handleBack = () => {
    const currentStep = steps?.find((step) => step.status.toUpperCase() === 'ACTIVE');
    const { order } = currentStep;
    let nuevoStep = currentStep?.order - 1;

    // Previsualizar --> Profesional/Paciente/Cliente
    if (order === 6) {
      if (usuarioAuth.IdTipoUsuario === TIPO_USUARIO_PACIENTE) {
        nuevoStep = 4;
      } else if (usuarioAuth.IdTipoUsuario === TIPO_USUARIO_CLIENTE) {
        nuevoStep = 5;
      } else if (usuarioAuth.IdTipoUsuario === TIPO_USUARIO_INTERNO) {
        nuevoStep = 3;
      }
    }

    // Profesional/Paciente/Cliente --> Delegación
    if (order === 3 || order === 4 || order === 5) {
      nuevoStep = 2;
    }

    setActiveStep(nuevoStep);
    setSteps(steps?.map((step) => {
      if (step.order === nuevoStep) {
        return { ...step, status: 'ACTIVE' };
      } else if (step.order < nuevoStep) {
        return { ...step, status: 'COMPLETED' };
      } else {
        return { ...step, status: 'INACTIVE' };
      }
    }));
  };

  // validación del step
  const isStepValid = (step) => {

    switch (step) {
      // usuario
      case 0:
        if (usuarioAuth.Id <= 0) {
          toast.error("Debe buscar un Usuario en el autenticador.");
          return false;
        }
        break;
      // rol
      case 1:
        if (rolesSeleccionados.length <= 0) {
          toast.error("Debe seleccionar al menos un Rol.");
          return false;
        }
        break;
      // delegación
      case 2:
        if (delegacionesSeleccionadas.length <= 0) {
          toast.error("Debe seleccionar al menos una Delegación.");
          return false;
        }

        if (delegacionOrigen <= 0) {
          toast.error("Debe seleccionar una Delegación de Origen.");
          return false;
        }
        break;
      // paciente
      case 4:
        if (usuarioAuth.IdTipoUsuario === TIPO_USUARIO_PACIENTE && (pacienteSeleccionado === "" || pacienteSeleccionado.idPaciente <= 0)) {
          toast.error("Debe seleccionar un Paciente.");
          return false;
        }
        break;
      // cliente
      case 5:
        if (usuarioAuth.IdTipoUsuario === TIPO_USUARIO_CLIENTE && clientesSeleccionados.length <= 0) {
          toast.error("Debe seleccionar al menos un Cliente.");
          return false;
        }
        break;
    }

    return true;
  };

  const viewStep = () => {
    switch (steps?.find((step) => step.status.toUpperCase() === 'ACTIVE')?.order) {
      case 0:
        return (
          <SeccionUsuario usuarioAuth={usuarioAuth} setUsuarioAuth={setUsuarioAuth} />);

      case 1:
        return (
          <SeccionRol rolesSeleccionados={rolesSeleccionados} setRolesSeleccionados={setRolesSeleccionados} />);

      case 2:
        return (
          <SeccionDelegacion
            regiones={regiones}
            setRegiones={setRegiones}
            delegaciones={delegaciones}
            setDelegaciones={setDelegaciones}
            delegacionesSeleccionadas={delegacionesSeleccionadas}
            setDelegacionesSeleccionadas={setDelegacionesSeleccionadas}
            delegacionOrigen={delegacionOrigen}
            setDelegacionOrigen={setDelegacionOrigen} />);


      case 3:
        return (
          <SeccionProfesional
            profesional={profesional}
            delegaciones={delegacionesSeleccionadas}
            setProfesional={setProfesional}
            roles={rolesSeleccionados}
            instituciones={instituciones}
            setInstituciones={setInstituciones} />);


      case 4:
        return (
          <SeccionPaciente
            pacienteSeleccionado={pacienteSeleccionado}
            delegs={delegacionesSeleccionadas}
            setPacienteSeleccionado={setPacienteSeleccionado} />);


      case 5:
        return (
          <SeccionCliente
            delegaciones={delegacionesSeleccionadas}
            clientesSeleccionados={clientesSeleccionados}
            setClientesSeleccionados={setClientesSeleccionados} />);


      case 6:
        return (
          <SeccionPreview
            usuario={usuarioAuth}
            roles={rolesSeleccionados}
            regiones={regiones}
            delegaciones={delegaciones}
            delegacionesSeleccionadas={delegacionesSeleccionadas}
            delegacionOrigen={delegacionOrigen}
            profesional={profesional}
            instituciones={instituciones}
            pacienteSeleccionado={pacienteSeleccionado}
            clientesSeleccionados={clientesSeleccionados}
            idTipoUsuario={usuarioAuth.IdTipoUsuario} />);


    }

  };

  const handleCancelEdit = () => {
    navigate("/usuarioadmin");
  };

  const MSaveUsuarioFull = gql`
    mutation MSaveUsuarioFull( $model: SaveUsuarioModelInput!){
      saveUsuarioFull(model: $model) 
      {
          success,
          error,
          valorEsperado
      }
  }`;

  const [saveUsuario, { loading, error, datos }] = useMutation(MSaveUsuarioFull, {
    onCompleted: (datos) => {
      setLoadingGrabar(false);
      if (datos.saveUsuarioFull.success) {
        if (parseInt(datos.saveUsuarioFull.valorEsperado, 10) > 0) {
          toast.success("Usuario grabado correctamente!");
          setTimeout(navigate('/usuarioadmin'), 2000);
        } else {
          toast.error(datos.saveUsuarioFull.error);
        }
      } else if (datos.saveUsuarioFull.error === 'ERRORDB' || parseInt(datos.saveUsuarioFull.error, 10) > 0) {
        setMensajeError(datos.saveUsuarioFull.error);
        return false;
      }
    },
    onError: (datos) => {
      setLoadingGrabar(false);
      setMensajeError("ERRORDB");
      return false;
    }
  });

  const handleSave = () => {
    // objeto completo para grabar
    let roles = [];
    if (rolesSeleccionados?.length > 0) {
      rolesSeleccionados?.map((rol) => {
        roles.push(rol.id);
      });
    }

    let clientes = [];
    if (clientesSeleccionados?.length > 0) {
      clientesSeleccionados.map((cliente) => {
        clientes.push(cliente.cod_Cliente);
      });
    }

    // las fechas de alta, caducidad y último login son seteadas por la base de datos
    // se completan datos para no generar error al recibir la info en el backend
    setUsuarioSave({
      ...usuarioSave,
      usuario: {
        "apellido": usuarioAuth.Apellido,
        "nombre": usuarioAuth.Nombre,
        "activo": 1,
        "cantIntFallidos": 0,
        "clave": "",
        "codSAP": "",
        "contentType": "",
        "email": usuarioAuth.Email,
        "fechaAlta": "2023-04-18",
        "fechaCaducidadClave": "2023-04-18",
        "fechaNacimiento": usuarioAuth.FechaNacimiento,
        "fechaUltimoLogin": "2023-04-18",
        "gestionComercial": "",
        "idBlanqueo": 0,
        "idCreador": 0,
        "idDelegacion": isNaN(delegacionOrigen) || typeof delegacionOrigen !== 'number' ? 0 : delegacionOrigen,
        "idFuncion": 0,
        "idmedico": 0,
        "idProfesional": profesional ? profesional.idProfesional : 0,
        "idServicio": 3,
        "idUsuario": usuario ? usuario.idUsuario : 0,
        "idUsuarioAlta": idUsuarioLogin,
        "idUsuarioAuth": usuarioAuth.Id,
        "idUsuarioOld": 0,
        "imagenPerfil": null,
        "imagenPerfilDecode": "",
        "ipUsuario": "",
        "numeroDoc": usuarioAuth.NumeroDocumento,
        "pcUsuario": "",
        "latitud": "",
        "longitud": "",
        "presetActivo": null,
        "sexo": usuarioAuth.Sexo,
        "telefono1": "",
        "telefono2": "",
        "telefono3": "",
        "tipoDocumento": usuarioAuth.TipoDocumento,
        "usuario": usuarioAuth.Usuario,
        "idTipoUsuario": usuarioAuth.IdTipoUsuario,
        "tipoUsuario": usuarioAuth.TipoUsuario,
        "usuIdPaciente": pacienteSeleccionado ? pacienteSeleccionado.idPaciente : 0
      },
      roles: roles,
      delegaciones: delegacionesSeleccionadas,
      clientes: clientes,
      instituciones: instituciones.map((institucion) => institucion.cod_Institucion)
    });
  };

  useEffect(() => {
    if (usuarioSave.usuario != null && usuarioSave.usuario != "") {
      setLoadingGrabar(true);
      saveUsuario({ variables: { model: usuarioSave } });
    }
  }, [usuarioSave]);

  const handleCloseDlgError = () => {
    setOpenDlgError(false);
  };

  const QGetUsuarioFull = gql`
        query QGetUsuarioFull ($idUsuario: Int!) {
            usuarioFull (idUsuario: $idUsuario)
                {
                    success,
                    error,
                    valorEsperado {
                      usuario {
                        id,
                        idUsuario,
                        usuario,
                        nombre,
                        apellido,
                        fechaNacimiento,
                        sexo,
                        idTipoDocumento,
                        tipoDocumento,
                        numeroDocumento,
                        idTipoUsuario,
                        tipoUsuario,
                        email,
                        telefono
                      },
                      roles {
                        id,
                        descripcion,
                        idFuncion,
                        idTipoProfesional,
                        activo
                      },
                      delegaciones,
                      delegacionOrigen,
                      profesional {
                        idProfesional,
                        idTipoProfesional,
                        apellido,
                        nombre,
                        numeroDoc,
                        tipoDoc
                      },
                      paciente {
                        idPaciente,
                        apellido,
                        nombre,
                        tipoDocumento,
                        numeroDocumento,
                        numeroAfiliado
                      },
                      clientes {
                        id,
                        cod_Cliente,
                        nom_Com,
                        cUIT,
                        domicilio,
                        localidad,
                        provincia
                      }
                      instituciones{
                        cod_Institucion,
                        nombre,
                        domicilio
                      }
                    }
                }
        }`;

  const [getDatosFull, { error: errorFull, data: dataFull }] = useLazyQuery(QGetUsuarioFull, {
    fetchPolicy: 'cache-and-network',
  });

  useEffect(() => {
    if (!dataFull?.usuarioFull?.success) return;

    const user = dataFull.usuarioFull.valorEsperado.usuario;

    setUsuarioAuth({
      Id: user.id,
      IdUsuario: user.idUsuario,
      Usuario: user.usuario,
      Clave: '',
      Apellido: user.apellido,
      Nombre: user.nombre,
      Email: user.email,
      IdTipoDocumento: user.IdTipoDocumento,
      TipoDocumento: user.tipoDocumento,
      NumeroDocumento: user.numeroDocumento,
      Sexo: user.sexo,
      FechaNacimiento: user.fechaNacimiento,
      Telefono: user.telefono,
      TipoUsuario: user.tipoUsuario,
      IdTipoUsuario: user.idTipoUsuario
    });

    setRolesSeleccionados(dataFull.usuarioFull.valorEsperado.roles);
    setDelegacionesSeleccionadas(dataFull.usuarioFull.valorEsperado.delegaciones);
    setDelegacionOrigen(dataFull.usuarioFull.valorEsperado.delegacionOrigen);
    setProfesional(dataFull.usuarioFull.valorEsperado.profesional);
    setInstituciones(dataFull.usuarioFull.valorEsperado.instituciones);
    setPacienteSeleccionado(dataFull.usuarioFull.valorEsperado.paciente);
    setClientesSeleccionados(dataFull.usuarioFull.valorEsperado.clientes);
  }, [dataFull]);

  useEffect(() => {
    if (errorFull) {
      setMensajeError("ERRORDB");
    }
  }, [errorFull]);

  return (
    <>
      <div style={{ width: '100%' }}>
        {viewStep()}
      </div>

      <ErrorDialog
        id="dlg-error-abm-usuarios"
        open={opendDlgError}
        onClose={handleCloseDlgError}
        mensaje={mensajeError} />

    </>);

}

const STEPS = [
  { stepName: 'Usuario *', status: 'ACTIVE', order: 0 },
  { stepName: 'Rol *', status: 'INACTIVE', order: 1 },
  { stepName: 'Delegación * ', status: 'INACTIVE', order: 2 },
  { stepName: 'Profesional', status: 'INACTIVE', order: 3 },
  { stepName: 'Paciente', status: 'INACTIVE', order: 4 },
  { stepName: 'Cliente', status: 'INACTIVE', order: 5 },
  { stepName: 'Previsualización', status: 'INACTIVE', order: 6 }];